import { render, staticRenderFns } from "./UserProfileDialog.vue?vue&type=template&id=6f7578a1&"
import script from "./UserProfileDialog.vue?vue&type=script&lang=js&"
export * from "./UserProfileDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileDialog.vue?vue&type=style&index=0&id=6f7578a1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VDialog,VIcon})
